import { create } from "zustand"
import { agentActivityScopeKey, type AgentActivityScope } from "@/lib/agent-activity-api"

type AgentActivityState = {
  scopeKey: string | null
  readyUnreadCount: number
  setReadyUnreadCount: (scope: AgentActivityScope, count: number) => void
  reset: () => void
}

export const useAgentActivityStore = create<AgentActivityState>((set) => ({
  scopeKey: null,
  readyUnreadCount: 0,
  setReadyUnreadCount: (scope, count) =>
    set({
      scopeKey: agentActivityScopeKey(scope),
      readyUnreadCount: Math.max(0, count),
    }),
  reset: () => set({ scopeKey: null, readyUnreadCount: 0 }),
}))
